export enum TableMapOrderStatusEnum {
  AVAILABLE = 'available',
  ASSIGNED = 'assigned',
  ORDERING = 'ordering',
  READY = 'ready',
  SERVED = 'served',
  BILLING = 'billing',
  PAID = 'paid',
  CLEANUP = 'cleanup',
  RESERVED = 'reserved',
  NOT_AVAILABLE = 'not_available',
}
